// LICENSE_CODE ZON
'use strict';

/*jslint browser:true, es6:true, node:true, react:true*/
import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { App_context } from 'hola_app_context';
import hola_login from '../login';
export var Login_required = () => {
  var history = useHistory();
  var on_close = () => {
    history.push('/');
  };
  var _useContext = useContext(App_context),
    is_client = _useContext.is_client;
  // XXX: need to wait for window.global_app_themes
  if (!is_client) return null;
  return /*#__PURE__*/React.createElement(hola_login.Login_modal, {
    no_switch: true,
    on_close: on_close,
    title: "Sign in to continue"
  });
};